<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <div class="navbar-brand">Daily Sales Report</div>
        <div class="ms-auto d-flex flex-row">
            <div class="d-flex flex-row align-items-center px-2" style="gap: 10px">
                <span>Month/Year</span>
                <input type="month" [(ngModel)]="filterMonth" (change)="monthChange($event)"
                    class="form-control form-control-sm" *ngIf="is_mario" />
                <select class="form-control form-control-sm" [(ngModel)]="filterMonth" (change)="monthChange($event)"
                    *ngIf="!is_mario">
                    <option *ngFor="let month of months" [value]="month.value">{{month.label}}</option>
                </select>
            </div>
            <!-- <button class="btn btn-success btn-sm" (click)="save()" *ngIf="permission['daily-sales-admin'] && !summary_checked">
            <span *ngIf="!is_saving">SAVE</span>
            <span *ngIf="is_saving">SAVING</span>
        </button> -->
        </div>
    </div>
</nav>
<div class="text-muted small px-3 pt-1" style="opacity:.5" *ngIf="configuration">UTC{{configuration.timezone || '+08:00'}}{{configuration.currency && configuration.currency !== 'none' ? ' · ' + configuration.currency : ''}}</div>
<hr />

<table>
    <tbody *ngFor="let week of weeks; let i = index">
        <tr>
            <th colspan="16">Week {{i + 1}}</th>
        </tr>
        <tr>
            <th>Date</th>
            <th>Day</th>
            <th>Debit 进钱</th>
            <th>Credit 出钱</th>
            <th>GW Fees</th>
            <th>Balance</th>
            <th>Bonus</th>
            <th>New Member</th>
            <th>Old Member</th>
            <th>No Of Topup</th>
            <th>Bank In Capital</th>
            <th>Bank Withdraw</th>
            <th *ngIf="permission['daily-sales-admin']">Adj In</th>
            <th *ngIf="permission['daily-sales-admin']">Adj Out</th>
            <th>Checked</th>
            <th></th>
        </tr>
        <tr *ngFor="let day of week">
            <td style="background:#efdecd; color: #000; padding-left: 3px;; padding-right: 3px;">{{day.date | date:
                'dd'}}</td>
            <td style="background:#efdecd; color: #000; padding-left: 3px;; padding-right: 3px;">{{day.day}}</td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.debit < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.debit != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.debit | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.credit < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.credit != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.credit | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{(day.gw_fees ?? 0) | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.balance < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.balance != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{(day.balance ?? 0) | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.total_bonus < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.bonus != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.bonus | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold text-center">{{day.new_member}}</td>
            <td class="fw-bold text-center">{{day.old_member}}</td>
            <td class="fw-bold text-center">{{day.no_of_topup}}</td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.bank_in < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.bank_in != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.bank_in | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.bank_out < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.bank_out != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.bank_out | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold p-0" *ngIf="permission['daily-sales-admin']" style="width:50px"><input type="number"
                    [(ngModel)]="day.daily_adj_in" class="form-field text-center"
                    [readonly]="day.checked || summary_checked" [disabled]="isFutureDate(day.date) || is_saving"
                    (input)="updateBalance(day)" min="0" /></td>
            <td class="fw-bold p-0" *ngIf="permission['daily-sales-admin']" style="width:50px"><input type="number"
                    [(ngModel)]="day.daily_adj_out" class="form-field text-center"
                    [readonly]="day.checked || summary_checked" [disabled]="isFutureDate(day.date) || is_saving"
                    (input)="updateBalance(day)" min="0" /></td>
            <td style="width:50px" class="p-0"><input type="checkbox" [(ngModel)]="day.checked" [value]="true"
                    class="mx-auto d-block"
                    [disabled]="!permission['daily-sales-admin'] || isFutureDate(day.date) || summary_checked"
                    (input)="updateBalance(day, false)" /></td>
            <td>
                <svg *ngIf="day.data" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-info-circle-fill" viewBox="0 0 16 16" style="cursor: pointer;"
                    (click)="displayDebug(content, day)">
                    <path
                        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                </svg>
            </td>
        </tr>
        <tr class="total">
            <th colspan="2">Total</th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('debit', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('debit', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('credit', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('credit', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('gw_fees', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('balance', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('balance', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('total_bonus', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('bonus', week) | number: '1.2-2'}}</div>
            </th>
            <th class="text-center">{{sum('new_member', week) | number: '1.0-0'}}</th>
            <th class="text-center">{{sum('old_member', week) | number: '1.0-0'}}</th>
            <th class="text-center">{{sum('no_of_topup', week) | number: '1.0-0'}}</th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('bank_in', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('bank_in', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('bank_out', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('bank_out', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold text-center" *ngIf="permission['daily-sales-admin']">{{sum('daily_adj_in', week) |
                number: '1.2-2'}}</th>
            <th class="fw-bold text-center" *ngIf="permission['daily-sales-admin']">{{sum('daily_adj_out', week) |
                number: '1.2-2'}}</th>
            <th></th>
            <th></th>
        </tr>
        <tr>
            <th colspan="16" style="height:30px; background: var(--bs-body-bg)"></th>
        </tr>
    </tbody>

    <tbody>
        <tr>
            <th colspan="2"></th>
            <th>Debit 进钱</th>
            <th>Credit 出钱</th>
            <th>GW Fees</th>
            <th>Balance</th>
            <th>Bonus</th>
            <th>New Member</th>
            <th>Old Member</th>
            <th>No Of Topup</th>
            <th>Bank In Capital</th>
            <th>Bank Withdraw</th>
            <th *ngIf="permission['daily-sales-admin']"></th>
            <th *ngIf="permission['daily-sales-admin']"></th>
            <th></th>
            <th></th>

        </tr>
        <tr class="total-summary">
            <th colspan="2">Total</th>
            <th [ngClass]="{'text-danger': sum('debit', flattern(weeks)) < 0}">{{sum('debit', flattern(weeks)) | number:
                '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('credit', flattern(weeks)) < 0}">{{sum('credit', flattern(weeks)) |
                number: '1.2-2'}}</th>
            <th>{{sum('gw_fees', flattern(weeks)) | number: '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('balance', flattern(weeks)) < 0}">{{sum('balance', flattern(weeks)) | number: '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('bonus', flattern(weeks)) < 0}">{{sum('bonus', flattern(weeks)) | number:
                '1.2-2'}}</th>
            <th>{{sum('new_member', flattern(weeks)) | number: '1.0-0'}}</th>
            <th>{{sum('old_member', flattern(weeks)) | number: '1.0-0'}}</th>
            <th>{{sum('no_of_topup', flattern(weeks)) | number: '1.0-0'}}</th>
            <th [ngClass]="{'text-danger': sum('bank_id', flattern(weeks)) < 0}">{{sum('bank_in', flattern(weeks)) |
                number: '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('bank_out', flattern(weeks)) < 0}">{{sum('bank_out', flattern(weeks)) |
                number: '1.2-2'}}</th>
            <th class="fw-bold text-center" *ngIf="permission['daily-sales-admin']">{{sum('daily_adj_in',
                flattern(weeks)) | number: '1.2-2'}}</th>
            <th class="fw-bold text-center" *ngIf="permission['daily-sales-admin']">{{sum('daily_adj_out',
                flattern(weeks)) | number: '1.2-2'}}</th>
            <th></th>
            <th></th>
        </tr>
    </tbody>
</table>

<div class="row mt-4">
    <div class="col-12 col-md-6">
        <table>
            <thead>
                <tr>
                    <th colspan="4">
                        <div class="d-flex flex-row justify-content-between">
                            <span>Other Profit</span>
                            <span>Total Other Profit: {{total_profit | number: '1.2-2'}}</span>
                        </div>
                    </th>
                </tr>
                <tr>
                    <th>Date</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let other of other_profit">
                    <td>{{other.create_on | date: "dd-MM-yyyy"}}</td>
                    <td>{{other.debit ?? '-'}}</td>
                    <td>{{other.credit ?? '-'}}</td>
                    <td><button class="btn btn-danger btn-sm" (click)="removeOtherProfit(other.id)">Remove</button></td>
                </tr>
                <tr>
                    <td>{{today_date | date: 'dd-MM-yyyy'}}</td>
                    <td class="p-0"><input class="form-control form-control-sm form-field w-100" type="number"
                            [(ngModel)]="other.debit" /></td>
                    <td class="p-0"><input class="form-control form-control-sm form-field w-100" type="number"
                            [(ngModel)]="other.credit" /></td>
                    <td><button class="btn btn-sm btn-success w-100" (click)="saveOtherProfit()">SAVE</button></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-12 col-md-6">
        <table>
            <thead>
                <tr>
                    <th colspan="3">
                        <div class="d-flex flex-row justify-content-between"><span>Capital ({{filterMonth}})</span>
                            <span>Capital Balance: {{capital.balance | number: '1.2-2'}}</span></div>
                    </th>
                </tr>
                <tr>
                    <th>Debit</th>
                    <th>Credit</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="p-0"><input class="form-control form-control-sm form-field w-100" type="number"
                            [(ngModel)]="capital.debit" /></td>
                    <td class="p-0"><input class="form-control form-control-sm form-field w-100" type="number"
                            [(ngModel)]="capital.credit" /></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2" class="p-2">
                        <button class="btn btn-sm btn-success w-100" (click)="saveCapital()">SAVE</button>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>

<ng-template #content let-modal>

    <div class="modal-header">

        <h3 class="modal-title">Debug Info</h3>

    </div>
    <div class="modal-body" [innerHTML]="debug">
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
    </div>

</ng-template>
<app-company-share-report [report]="shareSplit" [daily]="true"></app-company-share-report>
